import { ChevronDown, Frame } from "lucide-react";
import { useState } from "react";

import { Input } from "@/components/ui/input";

import ToolbarButton from "./toolbar-button";

const BorderColorPicker: React.FC<
  React.ComponentProps<"button"> & {
    editorRef: React.RefObject<HTMLDivElement>;
  }
> = ({ editorRef }) => {
  const [borderColor, setBorderColor] = useState<string>("#000000");

  return (
    <>
      <ToolbarButton className="w-fit">
        <label className="relative flex w-full items-center gap-x-1">
          <Frame />
          Border Color
          <ChevronDown />
          <Input
            type="color"
            defaultValue={borderColor}
            onChange={(e) => {
              setBorderColor(e.target.value);
              if (editorRef.current) {
                editorRef.current.style.borderColor = e.target.value;
                // تنظیم border-style اگر وجود نداشته باشد
                if (
                  !editorRef.current.style.borderStyle ||
                  editorRef.current.style.borderStyle === "none"
                ) {
                  editorRef.current.style.borderStyle = "solid";
                }
                // تنظیم border-width اگر وجود نداشته باشد
                if (
                  !editorRef.current.style.borderWidth ||
                  editorRef.current.style.borderWidth === "0px"
                ) {
                  editorRef.current.style.borderWidth = "2px";
                }
              }
            }}
            className="absolute size-0 cursor-pointer opacity-0"
          />
        </label>
      </ToolbarButton>
    </>
  );
};
export default BorderColorPicker;